import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loading from '../../components/Loading'
import PlansSelectionView from '../../components/PlansSelectionView'
import { StepSuccessWhatsapp } from './stepSuccessWhatsapp'
import { useAuth } from '../../hooks/useAuth'
import {
  completeStripeCheckoutReturn,
  hasStripeCheckoutReturn,
} from '../../utils/stripeCheckoutReturn'

function PlanCheckout() {
  const { userData } = useAuth()
  const navigate = useNavigate()
  const [isSuccess, setIsSuccess] = useState(false)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const sessionId = queryParams.get('session_id')
    const origin = queryParams.get('origin')

    if (!hasStripeCheckoutReturn(window.location.search)) return

    const handleCheckoutSuccess = async () => {
      await completeStripeCheckoutReturn(sessionId || undefined)

      if (origin === 'mobile') {
        setIsSuccess(true)
      } else {
        navigate('/NewPublicationPageIA', {
          state: {
            step: 'stepColorPalette',
            initialParameterization: true,
          },
        })
      }
    }

    handleCheckoutSuccess()
  }, [navigate])

  if (!userData) return <Loading />

  if (isSuccess) {
    return (
      <StepSuccessWhatsapp />
    )
  }

  const queryParams = new URLSearchParams(window.location.search)
  const origin = queryParams.get('origin')
  const returnUrl = origin
    ? `${window.location.origin}/PlanCheckout?origin=${origin}`
    : `${window.location.origin}/PlanCheckout`

  return (
    <PlansSelectionView
      showCancelAccount={false}
      showBackButton={false}
      returnUrl={returnUrl}
      allowCurrentPlanSelection={true}
      onSelectFreePlan={() => navigate('/NewPublicationPageIA', {
        state: {
          step: 'stepColorPalette',
          initialParameterization: true,
        },
      })}
    />
  )
}

export default PlanCheckout
